"use client";

import IconGlobe from "@/icons/globe.svg";
import { localesMap } from '@/lib/translations/locales'
import {Tooltip} from "@/components/ui/tooltip";
import React from "react";
import {UserProfile} from "@/components/custom/header/userProfile";
import {ContactButton} from "@/components/custom/header/mainmenu/contactButton";
import IconFlagGermany from "@/icons/flags/germany.svg";
import IconFlagFrance from "@/icons/flags/france.svg";
import IconFlagNetherlands from "@/icons/flags/netherlands.svg";
import IconFlagSwitzerland from "@/icons/flags/switzerland.svg";
import IconFlagAustria from "@/icons/flags/austria.svg";
import IconFlagPoland from "@/icons/flags/poland.svg";
import IconFlagUK from "@/icons/flags/uk.svg";
import IconFlagCanada from "@/icons/flags/canada.svg";
import IconFlagItaly from "@/icons/flags/italy.svg";
import IconFlagRussia from "@/icons/flags/russia.svg";
import IconFlagUSA from "@/icons/flags/usa.svg";
import {Badge} from "@/components/ui/badge";
import {IoMdHelpCircleOutline} from "react-icons/io";
import {useTour} from "@/hooks/useTourName";
import {useFlags} from "@/contexts/FlagsContext";

const iconMap: {[key: string]: any} = {
    INT: <IconGlobe />,
    DE: <IconFlagGermany />,
    FR: <IconFlagFrance />,
    NL: <IconFlagNetherlands />,
    CH: <IconFlagSwitzerland />,
    AT: <IconFlagAustria />,
    PL: <IconFlagPoland />,
    UK: <IconFlagUK />,
    CA: <IconFlagCanada />,
    IT: <IconFlagItaly />,
    RU: <IconFlagRussia />,
    US: <IconFlagUSA />
}

interface NavigationProps {
    navAccountTranslation: {
        label: string;
        tooltip: string;
    },
    navBookmarksTranslation: {
        label: string;
        tooltip: string;
    },
    navLanguageTranslation: {
        tooltip: string;
    }
    langSelectorOpen: boolean,
    setLangSelectorOpen: (langSelector: boolean) => void,
    locale: string,
    env: string;
    entraIdIssuer: string;
}

export function Navigation({ navAccountTranslation, navBookmarksTranslation, langSelectorOpen, setLangSelectorOpen, navLanguageTranslation, locale, env, entraIdIssuer }: NavigationProps) {
    const [language, region] = locale.split("-");

    const isProd = !(env === "local" || env === "dev" || env === "stag");

    const {tourCount, startTour} = useTour();
    const flags = useFlags();

    return (
        <nav className='navigation'>
            <ul className='navigation__list flex flex-row gap-4 md:gap-8 items-center'>
                <Tooltip content={navLanguageTranslation.tooltip} delay={100}>
                    <li
                        className='navigation__item flex cursor-pointer select-none flex-row gap-2 hover:text-cyan'
                        onClick={() => setLangSelectorOpen(!langSelectorOpen)}
                    >
                       <div className={"flex items-center gap-4"}>
                           <span className='sm:inline'>{localesMap[language]}</span>
                           <div className='icon flex-none w-6 h-6 flex items-center justify-center text-primary-foreground bg-primary rounded-full overflow-hidden'>
                               {iconMap[region]}
                           </div>
                       </div>
                    </li>
                </Tooltip>
                <UserProfile
                    locale={locale}
                    labels={{
                        watchlist: navBookmarksTranslation.label,
                        logout: "Logout"
                    }}
                    env={env}
                    entraIdIssuer={entraIdIssuer}
                />
                <div className={"flex items-center gap-1"}>
                    <ContactButton />
                    {flags.helpButton && (
                        <div className={"relative cursor-pointer"} onClick={startTour}>
                            {tourCount > 0 && (<Badge className={"absolute left-3 -top-3"} variant={"cyan"}>{tourCount}</Badge>)}
                            <IoMdHelpCircleOutline className={"size-6 hover:text-secondary transition-colors"} />
                        </div>
                    )}
                </div>
            </ul>
        </nav>
    )
}

